import { Component, Input, } from '@angular/core';
import { IconService } from '../../shared/icon.service';
import { VisitasService } from '../visitas.service';
import { GraphicService } from '../../shared/graphic.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfiguracaoInfoCliente } from '../../shared/Util';
import { BoxInfoAlertService } from '../../box-info-alert/box-info-alert.service';
import { environment } from '../../../environments/environment';
import { CurrencyPipe, DatePipe, NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import { CpfCnpjPipe } from '../../../../src/app/shared/cpf-cnpj.pipe';





@Component({
  selector: 'app-status-cliente-visita',
  templateUrl: './status-cliente-visita.component.html',
  styleUrls: ['./status-cliente-visita.component.css'],
  standalone: true,
  imports: [NgIf, NgFor, CpfCnpjPipe, NgClass, NgStyle, DatePipe, CurrencyPipe]
})
export class StatusClienteVisitaComponent {


  @Input() roteiro: any;
  @Input() index: number;
  @Input() ultimoRoteiro: boolean;
  @Input() dadosVisitas = [];
  clientes = [];
  carregandoClientes = false;
  msgLoading = ''
  ocorrencias: any[] = [];

  entregaAjudante = false;
  numeroRoteiroAtual = 0
  listaDeAcoes = []
  listaAcoesPorCliente = [];
  horarioInicioRoteiro = '00:00'
  configNomeClienteExibicao = ConfiguracaoInfoCliente.RazaoSocial;
  enumConfiguracaoInfoCliente = ConfiguracaoInfoCliente;
  clienteAtual: any = null; // controla qual cliente está com hover
  urlOcorrencias = '';

  constructor(
    private iconService: IconService,
    private visitasService: VisitasService,
    private graphicService: GraphicService,
    public boxInfoAlertService: BoxInfoAlertService,
    private sanitizer: DomSanitizer,

  ) { }

  ngOnInit() {
    this.urlOcorrencias = environment.url_telaOcorrencias + '/index.html' + window.location.search;
  }


  ngOnChanges(): void {
    this.iniciaClientes();
    if (this.roteiro.horarioInicioRoteiro != null) {
      this.horarioInicioRoteiro = this.retronarHoraString(this.roteiro.horarioInicioRoteiro);
    }
  }



  async iniciaClientes() {
    this.msgLoading = 'Carregando dados dos clientes';
    let clinteReduced = [];
    const infoRota = JSON.parse(this.roteiro.InfoRota);
    let consideraEndPed = infoRota.ConsideraEndPed ?? false
    if (infoRota.ConfigNomeClienteExibicao) {
      this.configNomeClienteExibicao = infoRota.ConfigNomeClienteExibicao
    }

    this.clientes = this.dadosVisitas.filter((pedido) => pedido.NumeroRoteiro == this.roteiro.NumeroRoteiro)
    this.clientes.forEach((cli) => {
      let temCliente = false;
      if (consideraEndPed) {
        temCliente = clinteReduced.some((cliente) =>
          cliente.CodigoCliente == cli.CodigoCliente &&
          cliente.Latitude == cli.Latitude &&
          cliente.Longitude == cli.Longitude
        );
      } else {
        temCliente = clinteReduced.some((cliente) => cliente.CodigoCliente == cli.CodigoCliente);
      }

      if (!temCliente) {
        if (consideraEndPed) {
          cli.pedidos = this.clientes.filter((cliente) => {
            if (cli.IdCliente && cliente.IdCliente) {
              return cliente.IdCliente == cli.IdCliente;
            }
            if (cli.NuPedidosConsideraEndPed) {
              try {
                let lista = typeof cli.NuPedidosConsideraEndPed === 'string'
                  ? JSON.parse(cli.NuPedidosConsideraEndPed)
                  : cli.NuPedidosConsideraEndPed;
                if (Array.isArray(lista)) {
                  return lista.some((item: any) => {
                    let nuPed = item.nuPed ?? item.NuPed;
                    let cdEmp = item.cdEmp ?? item.CdEmp;
                    let nuPedMatch = nuPed != null && nuPed == cliente.NumeroPedido;
                    let cdEmpMatch = (cdEmp && cliente.cdEmp && cdEmp != 0 && cliente.cdEmp != 0)
                      ? cdEmp == cliente.cdEmp
                      : true;
                    return nuPedMatch && cdEmpMatch;
                  });
                }
              } catch (e) {
                console.log("CATCH________iniciaClientes");
                console.log(e);
              }
            }
            return cliente.CodigoCliente == cli.CodigoCliente &&
              cliente.Latitude == cli.Latitude &&
              cliente.Longitude == cli.Longitude;
          });
        } else {
          cli.pedidos = this.clientes.filter((cliente) => cliente.CodigoCliente == cli.CodigoCliente);
        }
        clinteReduced.push(cli)
      }
    })

    this.clientes = clinteReduced;

    let contador = 1
    this.clientes.forEach(async (cliente) => {
      let temOcorrencia = cliente.problemaReportado;
      let regiaoRisco = cliente.RegiaoRisco
      let codigoAcao = cliente.CodigoAcao;
      let IdRoteiroPedidoSituacao = cliente.IdRoteiroPedidoSituacao;
      let urlLimpo = this.iconService.iconeCliente(contador, codigoAcao, temOcorrencia, 0, IdRoteiroPedidoSituacao, 0, regiaoRisco);
      cliente.icon = urlLimpo
      contador++;
    })
  }

  statusOcorrencia(idStatus) {
    switch (idStatus) {
      case 1:
      case 2: return { msg: 'Em andamento', cor: '#81D4FA', caminho: 'assets/img/icons/icon_pill_oc_andamento.svg' };
      case 3: return { msg: 'Finalizado', cor: '#7FF3B9', caminho: 'assets/img/icons/icon-status-finalizado.svg' };
    }
  }




  async getOcorrencias(codigoCliente: number | string) {
    this.ocorrencias = [];
    const listaOcorrencias = this.boxInfoAlertService.alertRouterPorRoteiro || [];
    this.ocorrencias = listaOcorrencias.filter(
      (c) => c.CodigoCliente == codigoCliente
    );
  }


  async exibirPopup(cliente: any, event: MouseEvent): Promise<void> {
    this.clienteAtual = cliente;

    await this.getOcorrencias(cliente.CodigoCliente);

    // só abre se ainda for o mesmo cliente com hover
    if (this.clienteAtual !== cliente) return;

    cliente.mostrarPopup = true;

    if (cliente.NumeroRoteiro != this.numeroRoteiroAtual && !this.carregandoClientes) {
      this.carregandoClientes = true;
      this.msgLoading = 'Aguarde, consultando ações do cliente'
      this.listaDeAcoes = await this.visitasService.getListaDeAcoes(cliente.NumeroRoteiro);
      this.carregandoClientes = false;
      this.numeroRoteiroAtual = cliente.NumeroRoteiro
    }

    if (this.clienteAtual !== cliente) return;

    let acoes = this.listaDeAcoes.filter(cli => cliente.CodigoCliente == cli.CodigoCliente);
    acoes.forEach((acao) => {
      let informacoes = JSON.parse(acao.Informacoes).CoordAjudante
      this.entregaAjudante = informacoes == 1 ? true : false;
    })

    this.listaAcoesPorCliente = this.graphicService.iconeAcaoPopup(acoes);
    this.listaAcoesPorCliente.forEach(element => {
      element.image = this.getIconeBase64(element.icone)
    });
  }

  esconderPopup(cliente: any): void {
    this.clienteAtual = null;
    cliente.mostrarPopup = false;
  }


  getIconeBase64(icone) {
    return this.sanitizer.bypassSecurityTrustUrl(icone);
  }

  private retronarHoraString(dataParametro: string): string {
    dataParametro = dataParametro.replace('Z', '')
    const data = new Date(dataParametro);
    const hora = data.getHours();
    const minutos = data.getMinutes();
    const horaFormatada = (hora <= 9 ? '0' : '') + hora;
    const minutosFormatados = (minutos <= 9 ? '0' : '') + minutos;
    return `${horaFormatada}:${minutosFormatados}`;
  }

  abrirOcorrencia(item) {
    const opc6 = { roteiro: this.clientes[0].NumeroRoteiro, codigoOcorrencia: item.CodigoOcorrencia }
    const novaData = btoa(new Date().getUTCFullYear() + '-' + (new Date().getUTCMonth() + 1) + '-' + new Date().getUTCDate() + " " + new Date().getHours() + ":" + new Date().getMinutes());
    const analisaUrl = new URL(this.urlOcorrencias);
    analisaUrl.searchParams.set("opc4", novaData);
    const finalUrl = analisaUrl.toString();
    window.open(finalUrl + `&opc6=${btoa(JSON.stringify(opc6))}`, "_blank");
  }

  private isBase64Image(text: string): boolean {
    const base64ImagePrefixes = ['/9j/', 'iVBOR', 'R0lGO', 'Qk0', 'SUkq'];
    return base64ImagePrefixes.some(prefix => text.trimStart().startsWith(prefix));
  }

  async openModalMsgOc(item: any) {
    console.log("chegiou aquiii")
    const codigoOc = item.CodigoOcorrencia;
    const objMensagem = await this.boxInfoAlertService.getOcorrenciaMensagem(codigoOc);

    const mensagemValida = objMensagem.find(
      (msg: any) => msg?.Mensagem && !this.isBase64Image(msg.Mensagem)
    );

    const mensagemTexto = mensagemValida?.Mensagem ?? '';

    if (mensagemTexto.includes('Motivo:')) {
      const motivoMatch = mensagemTexto.match(/Motivo: <\/b>(.*?)(?:\\n|$)/);
      this.boxInfoAlertService.mensagemModal = motivoMatch ? motivoMatch[1].trim() : '';
    } else {
      this.boxInfoAlertService.mensagemModal = mensagemTexto.trim();
    }

    this.boxInfoAlertService.dataModal = mensagemValida?.Data ?? objMensagem[0]?.Data;

    // seta contexto para o popup-msg-oc usar via callback
    this.boxInfoAlertService.ocorrenciaAtualModal = item;
    this.boxInfoAlertService.abrirOcorrenciaCallback = (ocorrencia) => {
      this.abrirOcorrencia(ocorrencia);
    };

    this.boxInfoAlertService.abrirModalMensagemOc = true;
  }

  abreStreetViewPrincipal(lat: number, lng: number) {
    const url = `https://www.google.com/maps?q=&layer=c&cbll=${lat},${lng}`;
    window.open(url, '_blank');
  }
}
